import { LoanGovernmentSecurities } from './LoanGovernmentSecurities';

export default LoanGovernmentSecurities;
